(function () {
    const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

    $.each($('.countdown'), (i, el) => {
        updateCountdown($(el));
    });
    const x = setInterval(function() {
        $.each($('.countdown'), (i, el) => {
            updateCountdown($(el));
        });
    }, 1000);

    function updateCountdown(me) {
        let endDay = me.attr('data-end');
        let countDown = new Date(endDay).getTime();
        let now = new Date().getTime();
        let distance = countDown - now;

        me.find(".days").text(Math.floor(distance / (day)));
        me.find(".hours").text(Math.floor((distance % (day)) / (hour)));
        me.find(".minutes").text(Math.floor((distance % (hour)) / (minute)));
        me.find(".seconds").text(Math.floor((distance % (minute)) / second));

        //do something later when date is reached
        if (distance < 0) {
            clearInterval(x);
        }
    }
}());